/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__blocks__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formats__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_styles_index_scss__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_styles_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_styles_index_scss__);





Object(__WEBPACK_IMPORTED_MODULE_0__blocks__["a" /* default */])();
Object(__WEBPACK_IMPORTED_MODULE_1__formats__["a" /* default */])();

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = registerBlocks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ta_image__ = __webpack_require__(3);


var registerBlockType = wp.blocks.registerBlockType;

/**
 * Register gutenberg blocks.
 * 
 * @since 3.6
 */

function registerBlocks() {

    [__WEBPACK_IMPORTED_MODULE_0__ta_image__].forEach(function (block) {
        if (!block) return;

        var name = block.name,
            settings = block.settings;

        registerBlockType(name, settings);
    });
}

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "name", function() { return name; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "settings", function() { return settings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__edit__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var Fragment = wp.element.Fragment;
var __ = wp.i18n.__;

var _ref = wp.dom.getPhrasingContentSchema ? wp.dom : wp.blocks,
    getPhrasingContentSchema = _ref.getPhrasingContentSchema;

var _ref2 = wp.blockEditor ? wp.blockEditor : wp.editor,
    RichText = _ref2.RichText;

var _wp$components = wp.components,
    Path = _wp$components.Path,
    SVG = _wp$components.SVG;




var name = 'ta/image';

var blockAttributes = {
	url: {
		type: 'string',
		source: 'attribute',
		selector: 'img',
		attribute: 'src'
	},
	alt: {
		type: 'string',
		source: 'attribute',
		selector: 'img',
		attribute: 'alt',
		default: ''
	},
	caption: {
		type: 'string',
		source: 'html',
		selector: 'figcaption'
	},
	id: {
		type: 'number'
	},
	align: {
		type: 'string'
	},
	width: {
		type: 'number'
	},
	height: {
		type: 'number'
	},
	linkid: {
		type: 'number'
	},
	href: {
		type: 'string',
		source: 'attribute',
		selector: 'ta',
		attribute: 'href'
	},
	affiliateLink: {
		type: 'object'
	}
};

var imageSchema = {
	img: {
		attributes: ['src', 'alt'],
		classes: ['alignleft', 'aligncenter', 'alignright', 'alignnone', /^wp-image-\d+$/]
	}
};

var schema = {
	figure: {
		require: ['ta', 'img'],
		children: {
			ta: {
				attributes: ['href', 'linkid'],
				children: imageSchema
			},
			figcaption: {
				children: getPhrasingContentSchema()
			}
		}
	}
};

function getFirstAnchorAttributeFormHTML(html, attributeName) {
	var _document$implementat = document.implementation.createHTMLDocument(''),
	    body = _document$implementat.body;

	body.innerHTML = html;

	var firstElementChild = body.firstElementChild;


	if (firstElementChild && firstElementChild.nodeName === 'A') {
		return firstElementChild.getAttribute(attributeName) || undefined;
	}
}

var settings = {
	title: __('ThirstyAffiliates Image'),

	description: __('Insert an image with an affiliate link to make a visual statement.'),

	icon: wp.element.createElement(
		SVG,
		{ viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
		wp.element.createElement(Path, { d: "M0,0h24v24H0V0z", fill: "none" }),
		wp.element.createElement(Path, { d: "m19 5v14h-14v-14h14m0-2h-14c-1.1 0-2 0.9-2 2v14c0 1.1 0.9 2 2 2h14c1.1 0 2-0.9 2-2v-14c0-1.1-0.9-2-2-2z" }),
		wp.element.createElement(Path, { d: "m14.14 11.86l-3 3.87-2.14-2.59-3 3.86h12l-3.86-5.14z" })
	),

	category: 'common',

	keywords: ['img', // "img" is not translated as it is intended to reflect the HTML <img> tag.
	__('photo'), __('affiliate')],

	attributes: blockAttributes,

	getEditWrapperProps: function getEditWrapperProps(attributes) {
		var align = attributes.align,
		    width = attributes.width;

		if ('left' === align || 'center' === align || 'right' === align || 'wide' === align || 'full' === align) {
			return { 'data-align': align, 'data-resized': !!width };
		}
	},


	edit: __WEBPACK_IMPORTED_MODULE_1__edit__["a" /* default */],

	save: function save(_ref3) {
		var _classnames;

		var attributes = _ref3.attributes;
		var url = attributes.url,
		    alt = attributes.alt,
		    caption = attributes.caption,
		    align = attributes.align,
		    width = attributes.width,
		    height = attributes.height,
		    id = attributes.id,
		    linkid = attributes.linkid,
		    href = attributes.href;


		var classes = __WEBPACK_IMPORTED_MODULE_0_classnames___default()((_classnames = {}, _defineProperty(_classnames, "align" + align, align), _defineProperty(_classnames, 'is-resized', width || height), _classnames));

		var image = wp.element.createElement("img", {
			src: url,
			alt: alt,
			className: id ? "wp-image-" + id : null,
			width: width,
			height: height
		});

		var figure = wp.element.createElement(
			Fragment,
			null,
			wp.element.createElement(
				"ta",
				{ linkid: linkid, href: href },
				image
			),
			wp.element.createElement(RichText.Content, { tagName: "figcaption", value: caption })
		);

		if ('left' === align || 'right' === align || 'center' === align) {
			return wp.element.createElement(
				"div",
				{ className: "wp-block-image" },
				wp.element.createElement(
					"figure",
					{ className: classes },
					figure
				)
			);
		}

		return wp.element.createElement(
			"figure",
			{ className: "wp-block-image " + classes },
			figure
		);
	}
};

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pickRelevantMediaFiles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__image_size__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__search_input__ = __webpack_require__(7);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var _lodash = lodash,
    get = _lodash.get,
    isEmpty = _lodash.isEmpty,
    map = _lodash.map,
    last = _lodash.last,
    pick = _lodash.pick,
    compact = _lodash.compact;
var getPath = wp.url.getPath;
var _wp$i18n = wp.i18n,
    __ = _wp$i18n.__,
    sprintf = _wp$i18n.sprintf;
var _wp$element = wp.element,
    Component = _wp$element.Component,
    Fragment = _wp$element.Fragment,
    createRef = _wp$element.createRef;
var _wp$blob = wp.blob,
    getBlobByURL = _wp$blob.getBlobByURL,
    revokeBlobURL = _wp$blob.revokeBlobURL,
    isBlobURL = _wp$blob.isBlobURL;
var _wp$components = wp.components,
    Placeholder = _wp$components.Placeholder,
    Button = _wp$components.Button,
    ButtonGroup = _wp$components.ButtonGroup,
    PanelBody = _wp$components.PanelBody,
    ResizableBox = _wp$components.ResizableBox,
    SelectControl = _wp$components.SelectControl,
    Spinner = _wp$components.Spinner,
    TextControl = _wp$components.TextControl,
    TextareaControl = _wp$components.TextareaControl,
    Toolbar = _wp$components.Toolbar,
    withNotices = _wp$components.withNotices;
var withSelect = wp.data.withSelect;
var mediaUpload = wp.editor.mediaUpload;

var _ref = wp.blockEditor ? wp.blockEditor : wp.editor,
    InspectorControls = _ref.InspectorControls,
    BlockControls = _ref.BlockControls,
    RichText = _ref.RichText,
    BlockAlignmentToolbar = _ref.BlockAlignmentToolbar;

var withViewportMatch = wp.viewport.withViewportMatch;
var compose = wp.compose.compose;






/**
 * Module constants
 */
var MIN_SIZE = 20;
var LINK_DESTINATION_NONE = 'none';
var LINK_DESTINATION_MEDIA = 'media';
var LINK_DESTINATION_ATTACHMENT = 'attachment';
var LINK_DESTINATION_CUSTOM = 'custom';
var NEW_TAB_REL = 'noreferrer noopener';
var ALLOWED_MEDIA_TYPES = ['image'];

var pickRelevantMediaFiles = function pickRelevantMediaFiles(image) {
	var pickedImageProps = pick(image, ['alt_text', 'id', 'link']);
	var imageProps = _extends({}, pickedImageProps, { alt: pickedImageProps.alt_text });

	imageProps.url = get(image, ['sizes', 'large', 'url']) || get(image, ['media_details', 'sizes', 'large', 'source_url']) || image.url;

	var caption = '';

	if (typeof image.caption === 'string') {
		caption = image.caption;
	} else if (_typeof(image.caption) === 'object' && typeof image.caption.rendered === 'string') {
		caption = image.caption.rendered;
	}

	imageProps.caption = caption;

	return imageProps;
};

/**
 * Is the URL a temporary blob URL? A blob URL is one that is used temporarily
 * while the image is being uploaded and will not have an id yet allocated.
 *
 * @param {number=} id The id of the image.
 * @param {string=} url The url of the image.
 *
 * @return {boolean} Is the URL a Blob URL
 */
var isTemporaryImage = function isTemporaryImage(id, url) {
	return !id && isBlobURL(url);
};

/**
 * Is the url for the image hosted externally. An externally hosted image has no id
 * and is not a blob url.
 *
 * @param {number=} id  The id of the image.
 * @param {string=} url The url of the image.
 *
 * @return {boolean} Is the url an externally hosted url?
 */
var isExternalImage = function isExternalImage(id, url) {
	return url && !id && !isBlobURL(url);
};

var ImageEdit = function (_Component) {
	_inherits(ImageEdit, _Component);

	function ImageEdit(_ref2) {
		var attributes = _ref2.attributes;

		_classCallCheck(this, ImageEdit);

		var _this = _possibleConstructorReturn(this, (ImageEdit.__proto__ || Object.getPrototypeOf(ImageEdit)).apply(this, arguments));

		_this.updateAlt = _this.updateAlt.bind(_this);
		_this.updateAlignment = _this.updateAlignment.bind(_this);
		_this.onFocusCaption = _this.onFocusCaption.bind(_this);
		_this.onImageClick = _this.onImageClick.bind(_this);
		_this.onSelectImage = _this.onSelectImage.bind(_this);
		_this.updateImageURL = _this.updateImageURL.bind(_this);
		_this.updateWidth = _this.updateWidth.bind(_this);
		_this.updateHeight = _this.updateHeight.bind(_this);
		_this.updateDimensions = _this.updateDimensions.bind(_this);
		_this.getFilename = _this.getFilename.bind(_this);
		_this.toggleIsEditing = _this.toggleIsEditing.bind(_this);
		_this.onImageError = _this.onImageError.bind(_this);
		_this.onChangeInputValue = _this.onChangeInputValue.bind(_this);
		_this.autocompleteRef = createRef();
		_this.resetInvalidLink = _this.resetInvalidLink.bind(_this);
		_this.updateImageSelection = _this.updateImageSelection.bind(_this);
		_this.onSelectAffiliateImage = _this.onSelectAffiliateImage.bind(_this);
		_this.editAFfiliateImage = _this.editAFfiliateImage.bind(_this);

		_this.state = {
			captionFocused: false,
			isEditing: !attributes.url,
			inputValue: '',
			linkid: 0,
			post: null,
			showSuggestions: false,
			imageSelection: [],
			affiliateLink: null
		};
		return _this;
	}

	_createClass(ImageEdit, [{
		key: "componentDidMount",
		value: function componentDidMount() {
			var _this2 = this;

			var _props = this.props,
			    attributes = _props.attributes,
			    setAttributes = _props.setAttributes,
			    noticeOperations = _props.noticeOperations;
			var id = attributes.id,
			    _attributes$url = attributes.url,
			    url = _attributes$url === undefined ? '' : _attributes$url;


			if (isTemporaryImage(id, url)) {
				var file = getBlobByURL(url);

				if (file) {
					mediaUpload({
						filesList: [file],
						onFileChange: function onFileChange(_ref3) {
							var _ref4 = _slicedToArray(_ref3, 1),
							    image = _ref4[0];

							setAttributes(pickRelevantMediaFiles(image));
						},
						allowedTypes: ALLOWED_MEDIA_TYPES,
						onError: function onError(message) {
							noticeOperations.createErrorNotice(message);
							_this2.setState({ isEditing: true });
						}
					});
				}
			}
		}
	}, {
		key: "componentDidUpdate",
		value: function componentDidUpdate(prevProps) {
			var _prevProps$attributes = prevProps.attributes,
			    prevID = _prevProps$attributes.id,
			    _prevProps$attributes2 = _prevProps$attributes.url,
			    prevURL = _prevProps$attributes2 === undefined ? '' : _prevProps$attributes2;
			var _props$attributes = this.props.attributes,
			    id = _props$attributes.id,
			    _props$attributes$url = _props$attributes.url,
			    url = _props$attributes$url === undefined ? '' : _props$attributes$url;


			if (isTemporaryImage(prevID, prevURL) && !isTemporaryImage(id, url)) {
				revokeBlobURL(url);
			}

			if (!this.props.isSelected && prevProps.isSelected && this.state.captionFocused) {
				this.setState({
					captionFocused: false
				});
			}
		}
	}, {
		key: "onSelectImage",
		value: function onSelectImage(media) {

			if (!media || !media.url) {
				this.props.setAttributes({
					url: undefined,
					alt: undefined,
					id: undefined,
					caption: undefined
				});
				return;
			}

			var affiliateLink = this.state.affiliateLink;


			this.setState({
				isEditing: false
			});

			this.props.setAttributes(_extends({}, pickRelevantMediaFiles(media), {
				linkid: affiliateLink.id,
				href: affiliateLink.link,
				affiliateLink: affiliateLink,
				width: undefined,
				height: undefined
			}));
		}
	}, {
		key: "onImageError",
		value: function onImageError(url) {
			// Check if there's an embed block that handles this URL.
			var embedBlock = Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* createUpgradedEmbedBlock */])({ attributes: { url: url } });
			if (undefined !== embedBlock) {
				this.props.onReplace(embedBlock);
			}
		}
	}, {
		key: "onFocusCaption",
		value: function onFocusCaption() {
			if (!this.state.captionFocused) {
				this.setState({
					captionFocused: true
				});
			}
		}
	}, {
		key: "onImageClick",
		value: function onImageClick() {
			if (this.state.captionFocused) {
				this.setState({
					captionFocused: false
				});
			}
		}
	}, {
		key: "updateAlt",
		value: function updateAlt(newAlt) {
			this.props.setAttributes({ alt: newAlt });
		}
	}, {
		key: "updateAlignment",
		value: function updateAlignment(nextAlign) {
			var extraUpdatedAttributes = ['wide', 'full'].indexOf(nextAlign) !== -1 ? { width: undefined, height: undefined } : {};
			this.props.setAttributes(_extends({}, extraUpdatedAttributes, { align: nextAlign }));
		}
	}, {
		key: "updateImageURL",
		value: function updateImageURL(url) {
			this.props.setAttributes({ url: url, width: undefined, height: undefined });
		}
	}, {
		key: "updateWidth",
		value: function updateWidth(width) {
			this.props.setAttributes({ width: parseInt(width, 10) });
		}
	}, {
		key: "updateHeight",
		value: function updateHeight(height) {
			this.props.setAttributes({ height: parseInt(height, 10) });
		}
	}, {
		key: "updateDimensions",
		value: function updateDimensions() {
			var _this3 = this;

			var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
			var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

			return function () {
				_this3.props.setAttributes({ width: width, height: height });
			};
		}
	}, {
		key: "getFilename",
		value: function getFilename(url) {
			var path = getPath(url);
			if (path) {
				return last(path.split('/'));
			}
		}
	}, {
		key: "getLinkDestinationOptions",
		value: function getLinkDestinationOptions() {
			return [{ value: LINK_DESTINATION_NONE, label: __('None') }, { value: LINK_DESTINATION_MEDIA, label: __('Media File') }, { value: LINK_DESTINATION_ATTACHMENT, label: __('Attachment Page') }, { value: LINK_DESTINATION_CUSTOM, label: __('Custom URL') }];
		}
	}, {
		key: "toggleIsEditing",
		value: function toggleIsEditing() {
			this.setState({
				isEditing: !this.state.isEditing
			});
		}
	}, {
		key: "getImageSizeOptions",
		value: function getImageSizeOptions() {
			var _props2 = this.props,
			    imageSizes = _props2.imageSizes,
			    image = _props2.image;

			return compact(map(imageSizes, function (_ref5) {
				var name = _ref5.name,
				    slug = _ref5.slug;

				var sizeUrl = get(image, ['media_details', 'sizes', slug, 'source_url']);
				if (!sizeUrl) {
					return null;
				}
				return {
					value: sizeUrl,
					label: name
				};
			}));
		}
	}, {
		key: "onChangeInputValue",
		value: function onChangeInputValue(inputValue) {
			var post = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			var linkid = post ? post.id : 0;
			this.setState({ inputValue: inputValue, linkid: linkid, post: post });
		}
	}, {
		key: "resetInvalidLink",
		value: function resetInvalidLink() {
			this.setState({ invalidLink: false });
		}
	}, {
		key: "updateImageSelection",
		value: function updateImageSelection(imageSelection, affiliateLink) {
			this.setState({
				imageSelection: imageSelection,
				affiliateLink: affiliateLink
			});
		}
	}, {
		key: "onSelectAffiliateImage",
		value: function onSelectAffiliateImage(image) {
			var _this4 = this;

			if (isExternalImage(image.id, image.src)) {
				image.url = image.src;
				this.onSelectImage(image);
			} else {
				var request = wp.apiFetch({
					path: wp.url.addQueryArgs('/wp/v2/media/' + image.id, {
						context: 'edit',
						_locale: 'user'
					})
				});

				request.then(function (media) {
					media.url = media.source_url;
					_this4.onSelectImage(media);
				});
			}
		}
	}, {
		key: "editAFfiliateImage",
		value: function editAFfiliateImage() {
			var attributes = this.props.attributes;
			var affiliateLink = attributes.affiliateLink;


			this.setState({
				isEditing: true,
				imageSelection: affiliateLink.images,
				affiliateLink: affiliateLink
			});
		}
	}, {
		key: "render",
		value: function render() {
			var _this5 = this;

			var _state = this.state,
			    isEditing = _state.isEditing,
			    imageSelection = _state.imageSelection,
			    affiliateLink = _state.affiliateLink;
			var _props3 = this.props,
			    attributes = _props3.attributes,
			    setAttributes = _props3.setAttributes,
			    isLargeViewport = _props3.isLargeViewport,
			    isSelected = _props3.isSelected,
			    className = _props3.className,
			    maxWidth = _props3.maxWidth,
			    toggleSelection = _props3.toggleSelection,
			    isRTL = _props3.isRTL;
			var url = attributes.url,
			    alt = attributes.alt,
			    caption = attributes.caption,
			    align = attributes.align,
			    linkDestination = attributes.linkDestination,
			    width = attributes.width,
			    height = attributes.height,
			    linkid = attributes.linkid,
			    href = attributes.href;

			var toolbarEditButton = wp.element.createElement(
				Toolbar,
				{ label: __('ThirstyAffiliates Image Settings') },
				wp.element.createElement(Button, {
					className: "ta-edit-image-button components-icon-button components-toolbar__control",
					label: __('Edit ThirstyAffiliates Image'),
					icon: "edit",
					onClick: this.editAFfiliateImage
				})
			);

			var controls = wp.element.createElement(
				BlockControls,
				null,
				wp.element.createElement(BlockAlignmentToolbar, {
					value: align,
					onChange: this.updateAlignment
				}),
				toolbarEditButton
			);

			if (isEditing) {
				return wp.element.createElement(
					Fragment,
					null,
					controls,
					wp.element.createElement(
						Placeholder,
						{
							icon: "format-image",
							label: __("ThirstyAffiliates Image"),
							instructions: __("Search for an affiliate link and select image to insert.")
						},
						wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3__search_input__["a" /* default */], {
							updateImageSelection: this.updateImageSelection
						}),
						!!imageSelection.length && wp.element.createElement(
							"div",
							{ className: "ta-image-sel-wrap" },
							wp.element.createElement(
								"h3",
								null,
								affiliateLink.title + " " + __('attached images:')
							),
							wp.element.createElement(
								"div",
								{ className: "ta-image-selection" },
								imageSelection.map(function (image, index) {
									return wp.element.createElement(
										"button",
										{
											onClick: function onClick() {
												return _this5.onSelectAffiliateImage(image);
											}
										},
										wp.element.createElement("img", { src: image.src })
									);
								})
							)
						)
					)
				);
			}

			var classes = __WEBPACK_IMPORTED_MODULE_0_classnames___default()(className, {
				'wp-block-image': true,
				'is-transient': isBlobURL(url),
				'is-resized': !!width || !!height,
				'is-focused': isSelected
			});

			var isResizable = ['wide', 'full'].indexOf(align) === -1 && isLargeViewport;
			var imageSizeOptions = this.getImageSizeOptions();

			var getInspectorControls = function getInspectorControls(imageWidth, imageHeight) {
				return wp.element.createElement(
					InspectorControls,
					null,
					wp.element.createElement(
						PanelBody,
						{ title: __('Image Settings') },
						wp.element.createElement(TextareaControl, {
							label: __('Alt Text (Alternative Text)'),
							value: alt,
							onChange: _this5.updateAlt,
							help: __('Alternative text describes your image to people who can’t see it. Add a short description with its key details.')
						}),
						!isEmpty(imageSizeOptions) && wp.element.createElement(SelectControl, {
							label: __('Image Size'),
							value: url,
							options: imageSizeOptions,
							onChange: _this5.updateImageURL
						}),
						isResizable && wp.element.createElement(
							"div",
							{ className: "block-library-image__dimensions" },
							wp.element.createElement(
								"p",
								{ className: "block-library-image__dimensions__row" },
								__('Image Dimensions')
							),
							wp.element.createElement(
								"div",
								{ className: "block-library-image__dimensions__row" },
								wp.element.createElement(TextControl, {
									type: "number",
									className: "block-library-image__dimensions__width",
									label: __('Width'),
									value: width !== undefined ? width : '',
									placeholder: imageWidth,
									min: 1,
									onChange: _this5.updateWidth
								}),
								wp.element.createElement(TextControl, {
									type: "number",
									className: "block-library-image__dimensions__height",
									label: __('Height'),
									value: height !== undefined ? height : '',
									placeholder: imageHeight,
									min: 1,
									onChange: _this5.updateHeight
								})
							),
							wp.element.createElement(
								"div",
								{ className: "block-library-image__dimensions__row" },
								wp.element.createElement(
									ButtonGroup,
									{ "aria-label": __('Image Size') },
									[25, 50, 75, 100].map(function (scale) {
										var scaledWidth = Math.round(imageWidth * (scale / 100));
										var scaledHeight = Math.round(imageHeight * (scale / 100));

										var isCurrent = width === scaledWidth && height === scaledHeight;

										return wp.element.createElement(
											Button,
											{
												key: scale,
												isSmall: true,
												isPrimary: isCurrent,
												"aria-pressed": isCurrent,
												onClick: _this5.updateDimensions(scaledWidth, scaledHeight)
											},
											scale,
											"%"
										);
									})
								),
								wp.element.createElement(
									Button,
									{
										isSmall: true,
										onClick: _this5.updateDimensions()
									},
									__('Reset')
								)
							)
						)
					)
				);
			};

			// Disable reason: Each block can be selected by clicking on it
			/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/onclick-has-role, jsx-a11y/click-events-have-key-events */
			return wp.element.createElement(
				Fragment,
				null,
				controls,
				wp.element.createElement(
					"figure",
					{ className: classes },
					wp.element.createElement(
						__WEBPACK_IMPORTED_MODULE_2__image_size__["a" /* default */],
						{ src: url, dirtynessTrigger: align },
						function (sizes) {
							var imageWidthWithinContainer = sizes.imageWidthWithinContainer,
							    imageHeightWithinContainer = sizes.imageHeightWithinContainer,
							    imageWidth = sizes.imageWidth,
							    imageHeight = sizes.imageHeight;


							var filename = _this5.getFilename(url);
							var defaultedAlt = void 0;
							if (alt) {
								defaultedAlt = alt;
							} else if (filename) {
								defaultedAlt = sprintf(__('This image has an empty alt attribute; its file name is %s'), filename);
							} else {
								defaultedAlt = __('This image has an empty alt attribute');
							}

							var img =
							// Disable reason: Image itself is not meant to be interactive, but
							// should direct focus to block.
							/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
							wp.element.createElement(
								Fragment,
								null,
								wp.element.createElement(
									"ta",
									{ linkid: linkid, href: href },
									wp.element.createElement("img", { src: url, alt: defaultedAlt, onClick: _this5.onImageClick, onError: function onError() {
											return _this5.onImageError(url);
										} })
								),
								isBlobURL(url) && wp.element.createElement(Spinner, null)
							)
							/* eslint-enable jsx-a11y/no-noninteractive-element-interactions */
							;

							if (!isResizable || !imageWidthWithinContainer) {
								return wp.element.createElement(
									Fragment,
									null,
									getInspectorControls(imageWidth, imageHeight),
									wp.element.createElement(
										"div",
										{ style: { width: width, height: height } },
										img
									)
								);
							}

							var currentWidth = width || imageWidthWithinContainer;
							var currentHeight = height || imageHeightWithinContainer;

							var ratio = imageWidth / imageHeight;
							var minWidth = imageWidth < imageHeight ? MIN_SIZE : MIN_SIZE * ratio;
							var minHeight = imageHeight < imageWidth ? MIN_SIZE : MIN_SIZE / ratio;

							// With the current implementation of ResizableBox, an image needs an explicit pixel value for the max-width.
							// In absence of being able to set the content-width, this max-width is currently dictated by the vanilla editor style.
							// The following variable adds a buffer to this vanilla style, so 3rd party themes have some wiggleroom.
							// This does, in most cases, allow you to scale the image beyond the width of the main column, though not infinitely.
							// @todo It would be good to revisit this once a content-width variable becomes available.
							var maxWidthBuffer = maxWidth * 2.5;

							var showRightHandle = false;
							var showLeftHandle = false;

							/* eslint-disable no-lonely-if */
							// See https://github.com/WordPress/gutenberg/issues/7584.
							if (align === 'center') {
								// When the image is centered, show both handles.
								showRightHandle = true;
								showLeftHandle = true;
							} else if (isRTL) {
								// In RTL mode the image is on the right by default.
								// Show the right handle and hide the left handle only when it is aligned left.
								// Otherwise always show the left handle.
								if (align === 'left') {
									showRightHandle = true;
								} else {
									showLeftHandle = true;
								}
							} else {
								// Show the left handle and hide the right handle only when the image is aligned right.
								// Otherwise always show the right handle.
								if (align === 'right') {
									showLeftHandle = true;
								} else {
									showRightHandle = true;
								}
							}
							/* eslint-enable no-lonely-if */

							return wp.element.createElement(
								Fragment,
								null,
								getInspectorControls(imageWidth, imageHeight),
								wp.element.createElement(
									ResizableBox,
									{
										size: width && height ? {
											width: width,
											height: height
										} : undefined,
										minWidth: minWidth,
										maxWidth: maxWidthBuffer,
										minHeight: minHeight,
										maxHeight: maxWidthBuffer / ratio,
										lockAspectRatio: true,
										enable: {
											top: false,
											right: showRightHandle,
											bottom: true,
											left: showLeftHandle
										},
										onResizeStart: function onResizeStart() {
											toggleSelection(false);
										},
										onResizeStop: function onResizeStop(event, direction, elt, delta) {
											setAttributes({
												width: parseInt(currentWidth + delta.width, 10),
												height: parseInt(currentHeight + delta.height, 10)
											});
											toggleSelection(true);
										}
									},
									img
								)
							);
						}
					),
					(!RichText.isEmpty(caption) || isSelected) && wp.element.createElement(RichText, {
						tagName: "figcaption",
						placeholder: __('Write caption…'),
						value: caption,
						unstableOnFocus: this.onFocusCaption,
						onChange: function onChange(value) {
							return setAttributes({ caption: value });
						},
						isSelected: this.state.captionFocused,
						inlineToolbar: true
					})
				)
			);
			/* eslint-enable jsx-a11y/no-static-element-interactions, jsx-a11y/onclick-has-role, jsx-a11y/click-events-have-key-events */
		}
	}]);

	return ImageEdit;
}(Component);

/* harmony default export */ __webpack_exports__["a"] = (compose([withSelect(function (select, props) {
	var _select = select('core'),
	    getMedia = _select.getMedia;

	var _select2 = select('core/editor'),
	    getEditorSettings = _select2.getEditorSettings;

	var id = props.attributes.id;

	var _getEditorSettings = getEditorSettings(),
	    maxWidth = _getEditorSettings.maxWidth,
	    isRTL = _getEditorSettings.isRTL,
	    imageSizes = _getEditorSettings.imageSizes;

	return {
		image: id ? getMedia(id) : null,
		maxWidth: maxWidth,
		isRTL: isRTL,
		imageSizes: imageSizes
	};
}), withViewportMatch({ isLargeViewport: 'medium' }), withNotices])(ImageEdit));

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createUpgradedEmbedBlock; });
/* unused harmony export isFromWordPress */
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var WORDPRESS_EMBED_BLOCK = 'core-embed/wordpress';

var _lodash = lodash,
    includes = _lodash.includes;
var renderToString = wp.element.renderToString;
var createBlock = wp.blocks.createBlock;

/***
 * Creates a more suitable embed block based on the passed in props
 * and attributes generated from an embed block's preview.
 *
 * We require `attributesFromPreview` to be generated from the latest attributes
 * and preview, and because of the way the react lifecycle operates, we can't
 * guarantee that the attributes contained in the block's props are the latest
 * versions, so we require that these are generated separately.
 * See `getAttributesFromPreview` in the generated embed edit component.
 *
 * @param {Object}            props                 The block's props.
 * @param {Object}            attributesFromPreview Attributes generated from the block's most up to date preview.
 * @return {Object|undefined} A more suitable embed block if one exists.
 */

var createUpgradedEmbedBlock = function createUpgradedEmbedBlock(props, attributesFromPreview) {
	var preview = props.preview,
	    name = props.name;
	var url = props.attributes.url;


	if (!url) {
		return;
	}

	var matchingBlock = findBlock(url);

	// WordPress blocks can work on multiple sites, and so don't have patterns,
	// so if we're in a WordPress block, assume the user has chosen it for a WordPress URL.
	if (WORDPRESS_EMBED_BLOCK !== name && DEFAULT_EMBED_BLOCK !== matchingBlock) {
		// At this point, we have discovered a more suitable block for this url, so transform it.
		if (name !== matchingBlock) {
			return createBlock(matchingBlock, { url: url });
		}
	}

	if (preview) {
		var html = preview.html;

		// We can't match the URL for WordPress embeds, we have to check the HTML instead.

		if (isFromWordPress(html)) {
			// If this is not the WordPress embed block, transform it into one.
			if (WORDPRESS_EMBED_BLOCK !== name) {
				return createBlock(WORDPRESS_EMBED_BLOCK, _extends({
					url: url
				}, attributesFromPreview));
			}
		}
	}
};

var isFromWordPress = function isFromWordPress(html) {
	return includes(html, 'class="wp-embedded-content" data-secret');
};

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _lodash = lodash,
    noop = _lodash.noop;
var withGlobalEvents = wp.compose.withGlobalEvents;
var Component = wp.element.Component;

var ImageSize = function (_Component) {
	_inherits(ImageSize, _Component);

	function ImageSize() {
		_classCallCheck(this, ImageSize);

		var _this = _possibleConstructorReturn(this, (ImageSize.__proto__ || Object.getPrototypeOf(ImageSize)).apply(this, arguments));

		_this.state = {
			width: undefined,
			height: undefined
		};
		_this.bindContainer = _this.bindContainer.bind(_this);
		_this.calculateSize = _this.calculateSize.bind(_this);
		return _this;
	}

	_createClass(ImageSize, [{
		key: 'bindContainer',
		value: function bindContainer(ref) {
			this.container = ref;
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps) {
			if (this.props.src !== prevProps.src) {
				this.setState({
					width: undefined,
					height: undefined
				});
				this.fetchImageSize();
			}

			if (this.props.dirtynessTrigger !== prevProps.dirtynessTrigger) {
				this.calculateSize();
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.fetchImageSize();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			if (this.image) {
				this.image.onload = noop;
			}
		}
	}, {
		key: 'fetchImageSize',
		value: function fetchImageSize() {
			this.image = new window.Image();
			this.image.onload = this.calculateSize;
			this.image.src = this.props.src;
		}
	}, {
		key: 'calculateSize',
		value: function calculateSize() {
			var maxWidth = this.container.clientWidth;
			var exceedMaxWidth = this.image.width > maxWidth;
			var ratio = this.image.height / this.image.width;
			var width = exceedMaxWidth ? maxWidth : this.image.width;
			var height = exceedMaxWidth ? maxWidth * ratio : this.image.height;
			this.setState({ width: width, height: height });
		}
	}, {
		key: 'render',
		value: function render() {
			var sizes = {
				imageWidth: this.image && this.image.width,
				imageHeight: this.image && this.image.height,
				containerWidth: this.container && this.container.clientWidth,
				containerHeight: this.container && this.container.clientHeight,
				imageWidthWithinContainer: this.state.width,
				imageHeightWithinContainer: this.state.height
			};
			return wp.element.createElement(
				'div',
				{ ref: this.bindContainer },
				this.props.children(sizes)
			);
		}
	}]);

	return ImageSize;
}(Component);

/* harmony default export */ __webpack_exports__["a"] = (withGlobalEvents({
	resize: 'calculateSize'
})(ImageSize));

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var __ = wp.i18n.__;
var _wp$element = wp.element,
    Component = _wp$element.Component,
    createRef = _wp$element.createRef;
var _wp$components = wp.components,
    Spinner = _wp$components.Spinner,
    withSpokenMessages = _wp$components.withSpokenMessages,
    Popover = _wp$components.Popover,
    TextControl = _wp$components.TextControl;
var withInstanceId = wp.compose.withInstanceId;

var ThirstyURLInput = function (_Component) {
	_inherits(ThirstyURLInput, _Component);

	/**
  * Component constructor method.
  * 
  * @since 3.6
  * 
  * @param {*} param0 
  */
	function ThirstyURLInput(_ref) {
		var autocompleteRef = _ref.autocompleteRef;

		_classCallCheck(this, ThirstyURLInput);

		// this.onChange = this.onChange.bind( this );
		// this.onKeyDown = this.onKeyDown.bind( this );
		var _this = _possibleConstructorReturn(this, (ThirstyURLInput.__proto__ || Object.getPrototypeOf(ThirstyURLInput)).apply(this, arguments));

		_this.autocompleteRef = autocompleteRef || createRef();
		_this.inputRef = createRef();
		_this.searchAffiliateLinks = _this.searchAffiliateLinks.bind(_this);
		// this.updateSuggestions = throttle( this.updateSuggestions.bind( this ), 200 );

		_this.suggestionNodes = [];

		_this.state = {
			posts: [],
			showSuggestions: false,
			selectedSuggestion: null,
			loading: false
		};
		return _this;
	}

	/**
     * Component did update method.
     * 
     * @since 3.6
     */


	_createClass(ThirstyURLInput, [{
		key: "componentDidUpdate",
		value: function componentDidUpdate() {
			var _this2 = this;

			var _state = this.state,
			    showSuggestions = _state.showSuggestions,
			    selectedSuggestion = _state.selectedSuggestion;
			// only have to worry about scrolling selected suggestion into view
			// when already expanded

			if (showSuggestions && selectedSuggestion !== null && !this.scrollingIntoView) {
				this.scrollingIntoView = true;
				scrollIntoView(this.suggestionNodes[selectedSuggestion], this.autocompleteRef.current, {
					onlyScrollIfNeeded: true
				});

				setTimeout(function () {
					_this2.scrollingIntoView = false;
				}, 100);
			}
		}

		/**
      * Component unmount method.
      * 
      * @since 3.6
      */

	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			delete this.suggestionsRequest;
		}

		/**
      * Bind suggestion to node.
      * 
      * @param {*} index 
      */

	}, {
		key: "bindSuggestionNode",
		value: function bindSuggestionNode(index) {
			var _this3 = this;

			return function (ref) {
				_this3.suggestionNodes[index] = ref;
			};
		}
	}, {
		key: "searchAffiliateLinks",
		value: function searchAffiliateLinks(value) {
			var _this4 = this;

			// Show the suggestions after typing at least 2 characters=
			if (value.length < 2) {
				this.setState({
					showSuggestions: false,
					selectedSuggestion: null,
					loading: false
				});

				return;
			}

			this.setState({
				showSuggestions: true,
				selectedSuggestion: null,
				loading: true
			});

			var formData = new FormData();
			formData.append("action", "search_affiliate_links_query");
			formData.append("keyword", value);
			formData.append("paged", 1);
			formData.append("gutenberg", true);
			formData.append("with_images", true);

			// We are getting data via the WP AJAX instead of rest API as it is not possible yet
			// to filter results with category value. This is to prepare next update to add category filter.
			var request = fetch(ajaxurl, {
				method: "POST",
				body: formData
			});

			request.then(function (response) {
				return response.json();
			}).then(function (response) {

				if (!response.affiliate_links) return;

				var posts = response.affiliate_links;

				// A fetch Promise doesn't have an abort option. It's mimicked by
				// comparing the request reference in on the instance, which is
				// reset or deleted on subsequent requests or unmounting.
				if (_this4.suggestionsRequest !== request) {
					return;
				}

				_this4.setState({
					posts: posts,
					loading: false
				});

				if (!!posts.length) {
					_this4.props.debouncedSpeak(sprintf(_n('%d result found, use up and down arrow keys to navigate.', '%d results found, use up and down arrow keys to navigate.', posts.length), posts.length), 'assertive');
				} else {
					_this4.props.debouncedSpeak(__('No results.'), 'assertive');
				}
			}).catch(function () {
				if (_this4.suggestionsRequest === request) {
					_this4.setState({
						loading: false
					});
				}
			});

			this.suggestionsRequest = request;
		}

		/**
      * Set state when an affiliate link is selected.
      * 
      * @since 3.6
      * 
      * @param {*} post 
      */

	}, {
		key: "selectLink",
		value: function selectLink(post) {
			// this.props.onChange( post.link, post );
			this.setState({
				selectedSuggestion: post,
				showSuggestions: false
			});

			this.props.updateImageSelection(post.images, post);
		}

		/**
      * Callback handler for when affiliate link is selected.
      * 
      * @param {*} post 
      */

	}, {
		key: "handleOnClick",
		value: function handleOnClick(post) {
			this.selectLink(post);
			// Move focus to the input field when a link suggestion is clicked.
			// this.inputRef.current.focus();
		}
	}, {
		key: "render",
		value: function render() {
			var _this5 = this;

			var _props = this.props,
			    _props$value = _props.value,
			    value = _props$value === undefined ? '' : _props$value,
			    _props$autoFocus = _props.autoFocus,
			    autoFocus = _props$autoFocus === undefined ? true : _props$autoFocus,
			    instanceId = _props.instanceId;
			var _state2 = this.state,
			    showSuggestions = _state2.showSuggestions,
			    posts = _state2.posts,
			    selectedSuggestion = _state2.selectedSuggestion,
			    loading = _state2.loading;


			return wp.element.createElement(
				"div",
				{ "class": "edit-search-affiliate-links" },
				wp.element.createElement(
					"form",
					{
						className: "editor-format-toolbar__link-container-content block-editor-format-toolbar__link-container-content ta-link-search-popover",
						onSubmit: this.displayAffiliateImages
					},
					wp.element.createElement(TextControl, {
						type: "text",
						className: "ta-search-affiliate-links",
						placeholder: __("Type to search affiliate links"),
						onChange: this.searchAffiliateLinks,
						autocomplete: "off"
					}),
					loading && wp.element.createElement(Spinner, null),
					showSuggestions && !!posts.length && wp.element.createElement(
						Popover,
						{ position: "bottom", focusOnMount: false },
						wp.element.createElement(
							"div",
							{ "class": "affilate-links-suggestions" },
							posts.map(function (post, index) {
								return wp.element.createElement(
									"button",
									{
										key: post.id,
										role: "option",
										tabIndex: "-1",
										id: "editor-url-input-suggestion-" + instanceId + "-" + index,
										ref: _this5.bindSuggestionNode(index),
										className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('editor-url-input__suggestion block-editor-url-input__suggestion', {
											'is-selected': index === selectedSuggestion
										}),
										onClick: function onClick() {
											return _this5.handleOnClick(post);
										},
										"aria-selected": index === selectedSuggestion
									},
									post.title || __('(no title)')
								);
							})
						)
					)
				)
			);
		}
	}]);

	return ThirstyURLInput;
}(Component);

/* harmony default export */ __webpack_exports__["a"] = (withSpokenMessages(withInstanceId(ThirstyURLInput)));

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = registerFormats;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ta_link__ = __webpack_require__(9);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



var registerFormatType = wp.richText.registerFormatType;

/**
 * Register custom formats.
 * 
 * @since 3.6
 */

function registerFormats() {

    [__WEBPACK_IMPORTED_MODULE_0__ta_link__["a" /* taLink */]].forEach(function (_ref) {
        var name = _ref.name,
            settings = _objectWithoutProperties(_ref, ["name"]);

        return registerFormatType(name, settings);
    });
}

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return taLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inline__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var __ = wp.i18n.__;
var _wp$element = wp.element,
    Component = _wp$element.Component,
    Fragment = _wp$element.Fragment;
var _wp$components = wp.components,
    withSpokenMessages = _wp$components.withSpokenMessages,
    ToolbarGroup = _wp$components.ToolbarGroup,
    ToolbarButton = _wp$components.ToolbarButton;
var _wp$richText = wp.richText,
    getTextContent = _wp$richText.getTextContent,
    applyFormat = _wp$richText.applyFormat,
    removeFormat = _wp$richText.removeFormat,
    slice = _wp$richText.slice;
var isURL = wp.url.isURL;

var _ref = wp.blockEditor ? wp.blockEditor : wp.editor,
    RichTextShortcut = _ref.RichTextShortcut,
    BlockControls = _ref.BlockControls;

var _wp$components2 = wp.components,
    Path = _wp$components2.Path,
    SVG = _wp$components2.SVG;


var name = "ta/link";

/**
 * Custom Affiliate link format. When applied will wrap selected text with <ta href="" linkid=""></ta> custom element.
 * Custom element is implemented here as we are not allowed to use <a> tag due to Gutenberg limitations.
 * Element is converted to normal <a> tag on frontend via PHP script filtered on 'the_content'.
 *
 * @since 3.6
 */
var taLink = {
	name: name,
	title: __("Affiliate Link"),
	tagName: "ta",
	className: null,
	attributes: {
		url: "href",
		target: "target"
	},
	edit: withSpokenMessages(function (_Component) {
		_inherits(LinkEdit, _Component);

		/**
   * Component constructor.
   *
   * @since 3.6
   */
		function LinkEdit() {
			_classCallCheck(this, LinkEdit);

			var _this = _possibleConstructorReturn(this, (LinkEdit.__proto__ || Object.getPrototypeOf(LinkEdit)).apply(this, arguments));

			_this.addLink = _this.addLink.bind(_this);
			_this.stopAddingLink = _this.stopAddingLink.bind(_this);
			_this.onRemoveFormat = _this.onRemoveFormat.bind(_this);
			_this.state = {
				addingLink: false
			};
			return _this;
		}

		/**
   * Callback to set state to adding link status.
   *
   * @since 3.6
   */


		_createClass(LinkEdit, [{
			key: "addLink",
			value: function addLink() {
				var _props = this.props,
				    value = _props.value,
				    onChange = _props.onChange;

				var text = getTextContent(slice(value));

				if (text && isURL(text)) {
					onChange(applyFormat(value, { type: name, attributes: { url: text } }));
				} else {
					this.setState({ addingLink: true });
				}
			}

			/**
    * Callback to set state to stop adding link status.
    *
    * @since 3.6
    */

		}, {
			key: "stopAddingLink",
			value: function stopAddingLink() {
				this.setState({ addingLink: false });
			}

			/**
    * Remove format event callback.
    *
    * @since 3.6
    */

		}, {
			key: "onRemoveFormat",
			value: function onRemoveFormat() {
				var _props2 = this.props,
				    value = _props2.value,
				    onChange = _props2.onChange,
				    speak = _props2.speak;


				onChange(removeFormat(value, name));
				speak(__("Affiliate Link removed."), "assertive");
			}

			/**
    * Component render method.
    *
    * @since 3.6
    */

		}, {
			key: "render",
			value: function render() {
				var _props3 = this.props,
				    isActive = _props3.isActive,
				    activeAttributes = _props3.activeAttributes,
				    value = _props3.value,
				    onChange = _props3.onChange,
				    contentRef = _props3.contentRef;


				return wp.element.createElement(
					Fragment,
					null,
					wp.element.createElement(RichTextShortcut, {
						type: "access",
						character: "s",
						onUse: this.onRemoveFormat
					}),
					wp.element.createElement(RichTextShortcut, {
						type: "primary",
						character: "l",
						onUse: this.addLink
					}),
					wp.element.createElement(RichTextShortcut, {
						type: "primaryShift",
						character: "l",
						onUse: this.onRemoveFormat
					}),
					isActive && wp.element.createElement(
						BlockControls,
						null,
						wp.element.createElement(
							ToolbarGroup,
							null,
							wp.element.createElement(ToolbarButton, {
								icon: "editor-unlink",
								title: __('Remove Affiliate Link'),
								className: "ta-unlink-button",
								onClick: this.onRemoveFormat,
								isActive: isActive
							})
						)
					),
					!isActive && wp.element.createElement(
						BlockControls,
						null,
						wp.element.createElement(
							ToolbarGroup,
							null,
							wp.element.createElement(ToolbarButton, {
								icon: wp.element.createElement(
									SVG,
									{ xmlns: "http://www.w3.org/2000/svg", width: "16.688", height: "9.875", viewBox: "0 0 16.688 9.875" },
									wp.element.createElement(Path, { id: "TA.svg", fill: "green", className: "cls-1", d: "M2.115,15.12H4.847L6.836,7.7H9.777l0.63-2.381H1.821L1.177,7.7H4.118Zm4.758,0H9.829l1.177-1.751h3.782l0.238,1.751h2.858L16.357,5.245H13.7Zm5.5-3.866,1.835-2.816,0.35,2.816H12.378Z", transform: "translate(-1.188 -5.25)" })
								),
								title: __('Affiliate Link'),
								className: "ta-link-button",
								onClick: this.addLink
							})
						)
					),
					wp.element.createElement(__WEBPACK_IMPORTED_MODULE_0__inline__["a" /* default */], {
						addingLink: this.state.addingLink,
						stopAddingLink: this.stopAddingLink,
						isActive: isActive,
						activeAttributes: activeAttributes,
						value: value,
						onChange: onChange,
						contentRef: contentRef
					})
				);
			}
		}]);

		return LinkEdit;
	}(Component))
};

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__url_popover__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__url_input__ = __webpack_require__(13);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var __ = wp.i18n.__;
var _wp$element = wp.element,
    Component = _wp$element.Component,
    createRef = _wp$element.createRef;
var _wp$components = wp.components,
    ExternalLink = _wp$components.ExternalLink,
    Button = _wp$components.Button,
    withSpokenMessages = _wp$components.withSpokenMessages;
var _wp$keycodes = wp.keycodes,
    LEFT = _wp$keycodes.LEFT,
    RIGHT = _wp$keycodes.RIGHT,
    UP = _wp$keycodes.UP,
    DOWN = _wp$keycodes.DOWN,
    BACKSPACE = _wp$keycodes.BACKSPACE,
    ENTER = _wp$keycodes.ENTER;
var _wp$url = wp.url,
    prependHTTP = _wp$url.prependHTTP,
    safeDecodeURI = _wp$url.safeDecodeURI,
    filterURLForDisplay = _wp$url.filterURLForDisplay;
var _wp$richText = wp.richText,
    create = _wp$richText.create,
    insert = _wp$richText.insert,
    isCollapsed = _wp$richText.isCollapsed,
    applyFormat = _wp$richText.applyFormat,
    getTextContent = _wp$richText.getTextContent,
    slice = _wp$richText.slice;


var stopKeyPropagation = function stopKeyPropagation(event) {
	return event.stopPropagation();
};

/**
 * Generates the format object that will be applied to the link text.
 *
 * @since 3.6
 *
 * @param {string}  url    The href of the link.
 * @param {boolean} linkid Affiliate link ID.
 * @param {Object}  text   The text that is being hyperlinked.
 *
 * @return {Object} The final format object.
 */
function createLinkFormat(_ref) {
	var url = _ref.url,
	    linkid = _ref.linkid,
	    text = _ref.text;

	var format = {
		type: "ta/link",
		attributes: {
			url: url,
			linkid: linkid.toString()
		}
	};

	return format;
}

/**
 * Check if input is being show.
 *
 * @since 3.6
 *
 * @param {Object} props Component props.
 * @param {Object} state Component state.
 */
function isShowingInput(props, state) {
	return props.addingLink || state.editLink;
}

/**
 * Affiliate Link editor JSX element.
 *
 * @since 3.6
 *
 * @param {Object} param0 Component props (destructred).
 */
var LinkEditor = function LinkEditor(_ref2) {
	var value = _ref2.value,
	    onChangeInputValue = _ref2.onChangeInputValue,
	    onKeyDown = _ref2.onKeyDown,
	    submitLink = _ref2.submitLink,
	    invalidLink = _ref2.invalidLink,
	    resetInvalidLink = _ref2.resetInvalidLink,
	    autocompleteRef = _ref2.autocompleteRef;
	return (
		// Disable reason: KeyPress must be suppressed so the block doesn't hide the toolbar
		/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
		wp.element.createElement(
			'form',
			{
				className: 'editor-format-toolbar__link-container-content block-editor-format-toolbar__link-container-content ta-link-search-popover',
				onKeyPress: stopKeyPropagation,
				onKeyDown: onKeyDown,
				onSubmit: submitLink
			},
			wp.element.createElement(__WEBPACK_IMPORTED_MODULE_3__url_input__["a" /* default */], {
				value: value,
				autoFocus: false,
				onChange: onChangeInputValue,
				autocompleteRef: autocompleteRef,
				invalidLink: invalidLink,
				resetInvalidLink: resetInvalidLink
			}),
			wp.element.createElement(Button, { icon: 'editor-break', label: __('Apply'), type: 'submit' })
		)
		/* eslint-enable jsx-a11y/no-noninteractive-element-interactions */

	);
};

/**
 * Affiliate link url viewer JSX element.
 *
 * @param {*} param0 Component props (destructred).
 */
var LinkViewerUrl = function LinkViewerUrl(_ref3) {
	var url = _ref3.url;

	var prependedURL = prependHTTP(url);
	var linkClassName = __WEBPACK_IMPORTED_MODULE_0_classnames___default()('editor-format-toolbar__link-container-value block-editor-format-toolbar__link-container-value', {
		'has-invalid-link': !Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* isValidHref */])(prependedURL)
	});

	if (!url) {
		return wp.element.createElement('span', { className: linkClassName });
	}

	return wp.element.createElement(
		ExternalLink,
		{
			className: linkClassName,
			href: url
		},
		filterURLForDisplay(safeDecodeURI(url))
	);
};

/**
 * Affiliate link viewer JSX element.
 *
 * @param {*} param0 Component props (destructred).
 */
var LinkViewer = function LinkViewer(_ref4) {
	var url = _ref4.url,
	    editLink = _ref4.editLink;

	return (
		// Disable reason: KeyPress must be suppressed so the block doesn't hide the toolbar
		/* eslint-disable jsx-a11y/no-static-element-interactions */
		wp.element.createElement(
			'div',
			{
				className: 'editor-format-toolbar__link-container-content block-editor-format-toolbar__link-container-content',
				onKeyPress: stopKeyPropagation
			},
			wp.element.createElement(LinkViewerUrl, { url: url }),
			wp.element.createElement(Button, { icon: 'edit', label: __('Edit'), onClick: editLink })
		)
		/* eslint-enable jsx-a11y/no-static-element-interactions */

	);
};

/**
 * Inline affiliate link UI Component.
 *
 * @since 3.6
 *
 * @param {*} param0 Component props (destructred).
 */

var InlineAffiliateLinkUI = function (_Component) {
	_inherits(InlineAffiliateLinkUI, _Component);

	function InlineAffiliateLinkUI() {
		_classCallCheck(this, InlineAffiliateLinkUI);

		var _this = _possibleConstructorReturn(this, (InlineAffiliateLinkUI.__proto__ || Object.getPrototypeOf(InlineAffiliateLinkUI)).apply(this, arguments));

		_this.editLink = _this.editLink.bind(_this);
		_this.submitLink = _this.submitLink.bind(_this);
		_this.onKeyDown = _this.onKeyDown.bind(_this);
		_this.onChangeInputValue = _this.onChangeInputValue.bind(_this);
		_this.onClickOutside = _this.onClickOutside.bind(_this);
		_this.resetState = _this.resetState.bind(_this);
		_this.autocompleteRef = createRef();
		_this.resetInvalidLink = _this.resetInvalidLink.bind(_this);

		_this.state = {
			inputValue: '',
			linkid: 0,
			post: null,
			invalidLink: false
		};
		return _this;
	}

	/**
  * Stop the key event from propagating up to ObserveTyping.startTypingInTextField.
  *
  * @since 3.6
  *
  * @param {Object} event Event object.
  */


	_createClass(InlineAffiliateLinkUI, [{
		key: 'onKeyDown',
		value: function onKeyDown(event) {
			if ([LEFT, DOWN, RIGHT, UP, BACKSPACE, ENTER].indexOf(event.keyCode) > -1) {
				event.stopPropagation();
			}
		}

		/**
   * Callback to set state when input value is changed.
   *
   * @since 3.6
   *
   * @param {*} inputValue
   * @param {*} post
   */

	}, {
		key: 'onChangeInputValue',
		value: function onChangeInputValue(inputValue) {
			var post = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			var linkid = post ? post.id : 0;
			this.setState({ inputValue: inputValue, linkid: linkid, post: post });
		}

		/**
   * Callback to set state when edit affiliate link (already inserted) is triggered.
   *
   * @since 3.6
   *
   * @param {*} event
   */

	}, {
		key: 'editLink',
		value: function editLink(event) {
			this.setState({ editLink: true });
			event.preventDefault();
		}

		/**
   * Callback to apply the affiliate link format to the selected text or position in the active block.
   *
   * @since 3.6
   *
   * @param {*} event
   */

	}, {
		key: 'submitLink',
		value: function submitLink(event) {
			var _props = this.props,
			    isActive = _props.isActive,
			    value = _props.value,
			    onChange = _props.onChange,
			    speak = _props.speak;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    linkid = _state.linkid,
			    post = _state.post;

			var url = prependHTTP(inputValue);
			var selectedText = getTextContent(slice(value));
			var format = createLinkFormat({
				url: url,
				linkid: linkid,
				text: selectedText
			});

			event.preventDefault();

			if (!linkid || !post) {
				this.setState({ invalidLink: true });
				return;
			}

			if (isCollapsed(value) && !isActive) {
				var toInsert = applyFormat(create({ text: post.title }), format, 0, url.length);
				onChange(insert(value, toInsert));
			} else {
				onChange(applyFormat(value, format));
			}

			this.resetState();

			if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* isValidHref */])(url)) {
				speak(__('Warning: the link has been inserted but may have errors. Please test it.'), 'assertive');
			} else if (isActive) {
				speak(__('Link edited.'), 'assertive');
			} else {
				speak(__('Link inserted'), 'assertive');
			}
		}

		/**
   * Callback to run when users clicks outside the popover UI.
   *
   * @since 3.6
   *
   * @param {*} event
   */

	}, {
		key: 'onClickOutside',
		value: function onClickOutside(event) {
			// The autocomplete suggestions list renders in a separate popover (in a portal),
			// so onClickOutside fails to detect that a click on a suggestion occured in the
			// LinkContainer. Detect clicks on autocomplete suggestions using a ref here, and
			// return to avoid the popover being closed.
			var autocompleteElement = this.autocompleteRef.current;
			if (autocompleteElement && autocompleteElement.contains(event.target)) {
				return;
			}

			this.resetState();
		}

		/**
   * Reset state callback.
   *
   * @since 3.6
   */

	}, {
		key: 'resetState',
		value: function resetState() {
			this.props.stopAddingLink();
			this.setState({ inputValue: '', editLink: false });
			this.resetInvalidLink();
		}

		/**
   * Reset invalid link state callback. Separated as we need to run this independently from resetState() callback.
   *
   * @since 3.6
   */

	}, {
		key: 'resetInvalidLink',
		value: function resetInvalidLink() {
			this.setState({ invalidLink: false });
		}

		/**
   * Component render method.
   *
   * @since 3.6
   */

	}, {
		key: 'render',
		value: function render() {
			var _props2 = this.props,
			    isActive = _props2.isActive,
			    url = _props2.activeAttributes.url,
			    addingLink = _props2.addingLink,
			    value = _props2.value,
			    contentRef = _props2.contentRef;


			if (!isActive && !addingLink) {
				return null;
			}

			var _state2 = this.state,
			    inputValue = _state2.inputValue,
			    invalidLink = _state2.invalidLink;

			var showInput = isShowingInput(this.props, this.state);

			return wp.element.createElement(
				__WEBPACK_IMPORTED_MODULE_2__url_popover__["a" /* default */],
				{
					onClickOutside: this.onClickOutside,
					onClose: this.resetState,
					focusOnMount: showInput ? 'firstElement' : false,
					addingLink: addingLink,
					invalidLink: invalidLink,
					value: value,
					contentRef: contentRef
				},
				showInput ? wp.element.createElement(LinkEditor, {
					value: inputValue,
					onChangeInputValue: this.onChangeInputValue,
					onKeyDown: this.onKeyDown,
					submitLink: this.submitLink,
					autocompleteRef: this.autocompleteRef,
					updateLinkId: this.updateLinkId,
					invalidLink: invalidLink,
					resetInvalidLink: this.resetInvalidLink
				}) : wp.element.createElement(LinkViewer, {
					url: url,
					editLink: this.editLink
				})
			);
		}
	}]);

	return InlineAffiliateLinkUI;
}(Component);

/* harmony default export */ __webpack_exports__["a"] = (withSpokenMessages(InlineAffiliateLinkUI));

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidHref;
var _lodash = lodash,
    startsWith = _lodash.startsWith;
var _wp$url = wp.url,
    getProtocol = _wp$url.getProtocol,
    isValidProtocol = _wp$url.isValidProtocol,
    getAuthority = _wp$url.getAuthority,
    isValidAuthority = _wp$url.isValidAuthority,
    getPath = _wp$url.getPath,
    isValidPath = _wp$url.isValidPath,
    getQueryString = _wp$url.getQueryString,
    isValidQueryString = _wp$url.isValidQueryString,
    getFragment = _wp$url.getFragment,
    isValidFragment = _wp$url.isValidFragment;

/**
 * Check for issues with the provided href.
 * 
 * @since 3.6
 *
 * @param {string} href The href.
 * @return {boolean} Is the href invalid?
 */

function isValidHref(href) {
	if (!href) {
		return false;
	}

	var trimmedHref = href.trim();

	if (!trimmedHref) {
		return false;
	}

	// Does the href start with something that looks like a URL protocol?
	if (/^\S+:/.test(trimmedHref)) {
		var protocol = getProtocol(trimmedHref);
		if (!isValidProtocol(protocol)) {
			return false;
		}

		// Add some extra checks for http(s) URIs, since these are the most common use-case.
		// This ensures URIs with an http protocol have exactly two forward slashes following the protocol.
		if (startsWith(protocol, 'http') && !/^https?:\/\/[^\/\s]/i.test(trimmedHref)) {
			return false;
		}

		var authority = getAuthority(trimmedHref);
		if (!isValidAuthority(authority)) {
			return false;
		}

		var path = getPath(trimmedHref);
		if (path && !isValidPath(path)) {
			return false;
		}

		var queryString = getQueryString(trimmedHref);
		if (queryString && !isValidQueryString(queryString)) {
			return false;
		}

		var fragment = getFragment(trimmedHref);
		if (fragment && !isValidFragment(fragment)) {
			return false;
		}
	}

	// Validate anchor links.
	if (startsWith(trimmedHref, '#') && !isValidFragment(trimmedHref)) {
		return false;
	}

	return true;
}

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var __ = wp.i18n.__;
var useState = wp.element.useState;
var _wp$components = wp.components,
    Popover = _wp$components.Popover,
    Button = _wp$components.Button;
var useAnchor = wp.richText.useAnchor;
var getRectangleFromRange = wp.dom.getRectangleFromRange;

var lastAnchorRect = null;

/**
 * Custom URL Popover component.
 *
 * @since 3.6
 */
function ThirstyURLPopover(_ref) {
    var children = _ref.children,
        renderSettings = _ref.renderSettings,
        addingLink = _ref.addingLink,
        invalidLink = _ref.invalidLink,
        _ref$position = _ref.position,
        position = _ref$position === undefined ? 'bottom center' : _ref$position,
        _ref$focusOnMount = _ref.focusOnMount,
        focusOnMount = _ref$focusOnMount === undefined ? 'firstElement' : _ref$focusOnMount,
        value = _ref.value,
        contentRef = _ref.contentRef,
        popoverProps = _objectWithoutProperties(_ref, ['children', 'renderSettings', 'addingLink', 'invalidLink', 'position', 'focusOnMount', 'value', 'contentRef']);

    /**
     * Get selected anchor text.
     *
     * Helper method for WP <6.1.
     *
     * @since 3.9
     */
    function getAnchorRect() {
        var selection = window.getSelection();
        var range = selection.rangeCount > 0 ? selection.getRangeAt(0) : null;

        if (!range) {
            return;
        }

        // Fix for the link UI jumping around the screen on WP 5.6
        if (selection.anchorNode.nodeType !== window.Node.TEXT_NODE) {
            return lastAnchorRect;
        }

        var rect = null;

        if (addingLink) {
            rect = getRectangleFromRange(range);
        } else {

            var element = range.startContainer;

            // If the caret is right before the element, select the next element.
            element = element.nextElementSibling || element;

            while (element.nodeType !== window.Node.ELEMENT_NODE) {
                element = element.parentNode;
            }

            var closest = element.closest('ta');
            if (closest) {
                rect = closest.getBoundingClientRect();
            }
        }

        lastAnchorRect = rect;

        return rect;
    }

    var _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        isSettingsExpanded = _useState2[0],
        setIsSettingsExpanded = _useState2[1];

    var showSettings = !!renderSettings && isSettingsExpanded();
    var anchorProps = void 0;

    if (useAnchor) {
        // Prefer useAnchor over useAnchorRef, this is WP 6.1+ only
        anchorProps = {
            anchor: useAnchor({
                editableContentElement: contentRef.current,
                value: value,
                settings: {
                    tagName: 'ta'
                }
            })
        };
    } else {
        anchorProps = {
            anchorRect: getAnchorRect()
        };
    }

    return wp.element.createElement(
        Popover,
        _extends({
            className: 'ta-url-popover editor-url-popover block-editor-url-popover',
            focusOnMount: focusOnMount,
            position: position
        }, anchorProps, popoverProps),
        wp.element.createElement(
            'div',
            { className: 'editor-url-popover__row' },
            children,
            !!renderSettings && wp.element.createElement(Button, {
                className: 'editor-url-popover__settings-toggle',
                icon: 'ellipsis',
                label: __('Link Settings'),
                onClick: function onClick() {
                    setIsSettingsExpanded(!isSettingsExpanded());
                },
                'aria-expanded': isSettingsExpanded()
            })
        ),
        showSettings && wp.element.createElement(
            'div',
            { className: 'editor-url-popover__row editor-url-popover__settings' },
            renderSettings()
        ),
        invalidLink && wp.element.createElement(
            'div',
            { className: 'ta-invalid-link' },
            __('Invalid affiliate link')
        )
    );
}

/* harmony default export */ __webpack_exports__["a"] = (ThirstyURLPopover);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dom_scroll_into_view__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dom_scroll_into_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dom_scroll_into_view__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var __ = wp.i18n.__;
var _lodash = lodash,
    throttle = _lodash.throttle;
var _wp$element = wp.element,
    Component = _wp$element.Component,
    createRef = _wp$element.createRef;
var _wp$keycodes = wp.keycodes,
    UP = _wp$keycodes.UP,
    DOWN = _wp$keycodes.DOWN,
    ENTER = _wp$keycodes.ENTER,
    TAB = _wp$keycodes.TAB;
var _wp$components = wp.components,
    Spinner = _wp$components.Spinner,
    withSpokenMessages = _wp$components.withSpokenMessages,
    Popover = _wp$components.Popover;
var withInstanceId = wp.compose.withInstanceId;

// Since URLInput is rendered in the context of other inputs, but should be
// considered a separate modal node, prevent keyboard events from propagating
// as being considered from the input.

var stopEventPropagation = function stopEventPropagation(event) {
	return event.stopPropagation();
};

/**
 * Custom URL Input component.
 *
 * @since 3.6
 */

var ThirstyURLInput = function (_Component) {
	_inherits(ThirstyURLInput, _Component);

	/**
  * Component constructor method.
  *
  * @since 3.6
  *
  * @param {*} param0
  */
	function ThirstyURLInput(_ref) {
		var autocompleteRef = _ref.autocompleteRef;

		_classCallCheck(this, ThirstyURLInput);

		var _this = _possibleConstructorReturn(this, (ThirstyURLInput.__proto__ || Object.getPrototypeOf(ThirstyURLInput)).apply(this, arguments));

		_this.onChange = _this.onChange.bind(_this);
		_this.onKeyDown = _this.onKeyDown.bind(_this);
		_this.autocompleteRef = autocompleteRef || createRef();
		_this.inputRef = createRef();
		_this.updateSuggestions = throttle(_this.updateSuggestions.bind(_this), 200);

		_this.suggestionNodes = [];

		_this.state = {
			posts: [],
			showSuggestions: false,
			selectedSuggestion: null
		};
		return _this;
	}

	/**
  * Component did update method.
  *
  * @since 3.6
  */


	_createClass(ThirstyURLInput, [{
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			var _this2 = this;

			var _state = this.state,
			    showSuggestions = _state.showSuggestions,
			    selectedSuggestion = _state.selectedSuggestion;
			// only have to worry about scrolling selected suggestion into view
			// when already expanded

			if (showSuggestions && selectedSuggestion !== null && !this.scrollingIntoView) {
				this.scrollingIntoView = true;
				__WEBPACK_IMPORTED_MODULE_1_dom_scroll_into_view___default()(this.suggestionNodes[selectedSuggestion], this.autocompleteRef.current, {
					onlyScrollIfNeeded: true
				});

				setTimeout(function () {
					_this2.scrollingIntoView = false;
				}, 100);
			}
		}

		/**
   * Component unmount method.
   *
   * @since 3.6
   */

	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			delete this.suggestionsRequest;
		}

		/**
   * Bind suggestion to node.
   *
   * @param {*} index
   */

	}, {
		key: 'bindSuggestionNode',
		value: function bindSuggestionNode(index) {
			var _this3 = this;

			return function (ref) {
				_this3.suggestionNodes[index] = ref;
			};
		}

		/**
   * Callback to show suggestions based on value inputted on search field.
   *
   * @since 3.6
   *
   * @param {*} value
   */

	}, {
		key: 'updateSuggestions',
		value: function updateSuggestions(value) {
			var _this4 = this;

			// Show the suggestions after typing at least 2 characters
			// and also for URLs
			if (value.length < 2 || /^https?:/.test(value)) {
				this.setState({
					showSuggestions: false,
					selectedSuggestion: null,
					loading: false
				});

				return;
			}

			this.setState({
				showSuggestions: true,
				selectedSuggestion: null,
				loading: true
			});

			var formData = new FormData();
			formData.append("action", "search_affiliate_links_query");
			formData.append("keyword", value);
			formData.append("paged", 1);
			formData.append("gutenberg", true);

			// We are getting data via the WP AJAX instead of rest API as it is not possible yet
			// to filter results with category value. This is to prepare next update to add category filter.
			var request = fetch(ajaxurl, {
				method: "POST",
				body: formData
			});

			request.then(function (response) {
				return response.json();
			}).then(function (response) {

				if (!response.affiliate_links) return;

				var posts = response.affiliate_links;

				// A fetch Promise doesn't have an abort option. It's mimicked by
				// comparing the request reference in on the instance, which is
				// reset or deleted on subsequent requests or unmounting.
				if (_this4.suggestionsRequest !== request) {
					return;
				}

				_this4.setState({
					posts: posts,
					loading: false
				});

				if (!!posts.length) {
					_this4.props.debouncedSpeak(sprintf(_n('%d result found, use up and down arrow keys to navigate.', '%d results found, use up and down arrow keys to navigate.', posts.length), posts.length), 'assertive');
				} else {
					_this4.props.debouncedSpeak(__('No results.'), 'assertive');
				}
			}).catch(function () {
				if (_this4.suggestionsRequest === request) {
					_this4.setState({
						loading: false
					});
				}
			});

			this.suggestionsRequest = request;
		}

		/**
   * Search input value change event callback method.
   *
   * @since 3.6
   *
   * @param {*} event
   */

	}, {
		key: 'onChange',
		value: function onChange(event) {
			this.props.resetInvalidLink();
			var inputValue = event.target.value;
			this.props.onChange(inputValue);
			this.updateSuggestions(inputValue);
		}

		/**
   * Keydown event callback. Handles selecting result via keyboard.
   *
   * @since 3.6
   *
   * @param {*} event
   */

	}, {
		key: 'onKeyDown',
		value: function onKeyDown(event) {
			var _state2 = this.state,
			    showSuggestions = _state2.showSuggestions,
			    selectedSuggestion = _state2.selectedSuggestion,
			    posts = _state2.posts,
			    loading = _state2.loading;
			// If the suggestions are not shown or loading, we shouldn't handle the arrow keys
			// We shouldn't preventDefault to allow block arrow keys navigation

			if (!showSuggestions || !posts.length || loading) {
				// In the Windows version of Firefox the up and down arrows don't move the caret
				// within an input field like they do for Mac Firefox/Chrome/Safari. This causes
				// a form of focus trapping that is disruptive to the user experience. This disruption
				// only happens if the caret is not in the first or last position in the text input.
				// See: https://github.com/WordPress/gutenberg/issues/5693#issuecomment-436684747
				switch (event.keyCode) {
					// When UP is pressed, if the caret is at the start of the text, move it to the 0
					// position.
					case UP:
						{
							if (0 !== event.target.selectionStart) {
								event.stopPropagation();
								event.preventDefault();

								// Set the input caret to position 0
								event.target.setSelectionRange(0, 0);
							}
							break;
						}
					// When DOWN is pressed, if the caret is not at the end of the text, move it to the
					// last position.
					case DOWN:
						{
							if (this.props.value.length !== event.target.selectionStart) {
								event.stopPropagation();
								event.preventDefault();

								// Set the input caret to the last position
								event.target.setSelectionRange(this.props.value.length, this.props.value.length);
							}
							break;
						}
				}

				return;
			}

			var post = this.state.posts[this.state.selectedSuggestion];

			switch (event.keyCode) {
				case UP:
					{
						event.stopPropagation();
						event.preventDefault();
						var previousIndex = !selectedSuggestion ? posts.length - 1 : selectedSuggestion - 1;
						this.setState({
							selectedSuggestion: previousIndex
						});
						break;
					}
				case DOWN:
					{
						event.stopPropagation();
						event.preventDefault();
						var nextIndex = selectedSuggestion === null || selectedSuggestion === posts.length - 1 ? 0 : selectedSuggestion + 1;
						this.setState({
							selectedSuggestion: nextIndex
						});
						break;
					}
				case TAB:
					{
						if (this.state.selectedSuggestion !== null) {
							this.selectLink(post);
							// Announce a link has been selected when tabbing away from the input field.
							this.props.speak(__('Link selected'));
						}
						break;
					}
				case ENTER:
					{
						if (this.state.selectedSuggestion !== null) {
							event.stopPropagation();
							this.selectLink(post);
						}
						break;
					}
			}
		}

		/**
   * Set state when an affiliate link is selected.
   *
   * @since 3.6
   *
   * @param {*} post
   */

	}, {
		key: 'selectLink',
		value: function selectLink(post) {
			this.props.onChange(post.link, post);
			this.setState({
				selectedSuggestion: null,
				showSuggestions: false
			});
		}

		/**
   * Callback handler for when affiliate link is selected.
   *
   * @param {*} post
   */

	}, {
		key: 'handleOnClick',
		value: function handleOnClick(post) {
			this.selectLink(post);
			// Move focus to the input field when a link suggestion is clicked.
			this.inputRef.current.focus();
		}

		/**
   * Component render method.
   *
   * @since 3.6
   */

	}, {
		key: 'render',
		value: function render() {
			var _this5 = this;

			var _props = this.props,
			    _props$value = _props.value,
			    value = _props$value === undefined ? '' : _props$value,
			    _props$autoFocus = _props.autoFocus,
			    autoFocus = _props$autoFocus === undefined ? true : _props$autoFocus,
			    instanceId = _props.instanceId,
			    invalidLink = _props.invalidLink;
			var _state3 = this.state,
			    showSuggestions = _state3.showSuggestions,
			    posts = _state3.posts,
			    selectedSuggestion = _state3.selectedSuggestion,
			    loading = _state3.loading;
			/* eslint-disable jsx-a11y/no-autofocus */

			return wp.element.createElement(
				'div',
				{ className: 'editor-url-input block-editor-url-input' },
				wp.element.createElement('input', {
					autoFocus: autoFocus,
					type: 'text',
					'aria-label': __('URL'),
					required: true,
					value: value,
					onChange: this.onChange,
					onInput: stopEventPropagation,
					placeholder: __('Paste URL or type to search'),
					onKeyDown: this.onKeyDown,
					role: 'combobox',
					'aria-expanded': showSuggestions,
					'aria-autocomplete': 'list',
					'aria-owns': 'editor-url-input-suggestions-' + instanceId,
					'aria-activedescendant': selectedSuggestion !== null ? 'editor-url-input-suggestion-' + instanceId + '-' + selectedSuggestion : undefined,
					ref: this.inputRef
				}),
				loading && wp.element.createElement(Spinner, null),
				showSuggestions && !!posts.length && !invalidLink && wp.element.createElement(
					Popover,
					{ position: 'bottom', noArrow: true, focusOnMount: false },
					wp.element.createElement(
						'div',
						{
							className: 'editor-url-input__suggestions block-editor-url-input__suggestions ta-editor-url-input__suggestions',
							id: 'editor-url-input-suggestions-' + instanceId,
							ref: this.autocompleteRef,
							role: 'listbox'
						},
						posts.map(function (post, index) {
							return wp.element.createElement(
								'button',
								{
									key: post.id,
									role: 'option',
									tabIndex: '-1',
									id: 'block-editor-url-input-suggestion-' + instanceId + '-' + index,
									ref: _this5.bindSuggestionNode(index),
									className: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('editor-url-input__suggestion block-editor-url-input__suggestion', {
										'is-selected': index === selectedSuggestion
									}),
									onClick: function onClick() {
										return _this5.handleOnClick(post);
									},
									'aria-selected': index === selectedSuggestion
								},
								post.title || __('(no title)'),
								post.thirstypay && wp.element.createElement(
									'span',
									{ className: 'thirstypay' },
									__('ThirstyPay™')
								)
							);
						})
					)
				)
			);
			/* eslint-enable jsx-a11y/no-autofocus */
		}
	}]);

	return ThirstyURLInput;
}(Component);

/* harmony default export */ __webpack_exports__["a"] = (withSpokenMessages(withInstanceId(ThirstyURLInput)));

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(15);

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(16);

function scrollIntoView(elem, container, config) {
  config = config || {};
  // document 归一化到 window
  if (container.nodeType === 9) {
    container = util.getWindow(container);
  }

  var allowHorizontalScroll = config.allowHorizontalScroll;
  var onlyScrollIfNeeded = config.onlyScrollIfNeeded;
  var alignWithTop = config.alignWithTop;
  var alignWithLeft = config.alignWithLeft;
  var offsetTop = config.offsetTop || 0;
  var offsetLeft = config.offsetLeft || 0;
  var offsetBottom = config.offsetBottom || 0;
  var offsetRight = config.offsetRight || 0;

  allowHorizontalScroll = allowHorizontalScroll === undefined ? true : allowHorizontalScroll;

  var isWin = util.isWindow(container);
  var elemOffset = util.offset(elem);
  var eh = util.outerHeight(elem);
  var ew = util.outerWidth(elem);
  var containerOffset = undefined;
  var ch = undefined;
  var cw = undefined;
  var containerScroll = undefined;
  var diffTop = undefined;
  var diffBottom = undefined;
  var win = undefined;
  var winScroll = undefined;
  var ww = undefined;
  var wh = undefined;

  if (isWin) {
    win = container;
    wh = util.height(win);
    ww = util.width(win);
    winScroll = {
      left: util.scrollLeft(win),
      top: util.scrollTop(win)
    };
    // elem 相对 container 可视视窗的距离
    diffTop = {
      left: elemOffset.left - winScroll.left - offsetLeft,
      top: elemOffset.top - winScroll.top - offsetTop
    };
    diffBottom = {
      left: elemOffset.left + ew - (winScroll.left + ww) + offsetRight,
      top: elemOffset.top + eh - (winScroll.top + wh) + offsetBottom
    };
    containerScroll = winScroll;
  } else {
    containerOffset = util.offset(container);
    ch = container.clientHeight;
    cw = container.clientWidth;
    containerScroll = {
      left: container.scrollLeft,
      top: container.scrollTop
    };
    // elem 相对 container 可视视窗的距离
    // 注意边框, offset 是边框到根节点
    diffTop = {
      left: elemOffset.left - (containerOffset.left + (parseFloat(util.css(container, 'borderLeftWidth')) || 0)) - offsetLeft,
      top: elemOffset.top - (containerOffset.top + (parseFloat(util.css(container, 'borderTopWidth')) || 0)) - offsetTop
    };
    diffBottom = {
      left: elemOffset.left + ew - (containerOffset.left + cw + (parseFloat(util.css(container, 'borderRightWidth')) || 0)) + offsetRight,
      top: elemOffset.top + eh - (containerOffset.top + ch + (parseFloat(util.css(container, 'borderBottomWidth')) || 0)) + offsetBottom
    };
  }

  if (diffTop.top < 0 || diffBottom.top > 0) {
    // 强制向上
    if (alignWithTop === true) {
      util.scrollTop(container, containerScroll.top + diffTop.top);
    } else if (alignWithTop === false) {
      util.scrollTop(container, containerScroll.top + diffBottom.top);
    } else {
      // 自动调整
      if (diffTop.top < 0) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  } else {
    if (!onlyScrollIfNeeded) {
      alignWithTop = alignWithTop === undefined ? true : !!alignWithTop;
      if (alignWithTop) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  }

  if (allowHorizontalScroll) {
    if (diffTop.left < 0 || diffBottom.left > 0) {
      // 强制向上
      if (alignWithLeft === true) {
        util.scrollLeft(container, containerScroll.left + diffTop.left);
      } else if (alignWithLeft === false) {
        util.scrollLeft(container, containerScroll.left + diffBottom.left);
      } else {
        // 自动调整
        if (diffTop.left < 0) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    } else {
      if (!onlyScrollIfNeeded) {
        alignWithLeft = alignWithLeft === undefined ? true : !!alignWithLeft;
        if (alignWithLeft) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    }
  }
}

module.exports = scrollIntoView;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;

function getClientPosition(elem) {
  var box = undefined;
  var x = undefined;
  var y = undefined;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top;

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;

  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
function _getComputedStyle(elem, name, computedStyle_) {
  var val = '';
  var d = elem.ownerDocument;
  var computedStyle = computedStyle_ || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;

    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}

var getComputedStyleX = undefined;
if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name = undefined;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop = undefined;
  var j = undefined;
  var i = undefined;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = undefined;
        if (prop === 'border') {
          cssProp = prop + which[i] + 'Width';
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj != null && obj == obj.window;
}

var domUtils = {};

each(['Width', 'Height'], function (name) {
  domUtils['doc' + name] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement['scroll' + name],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body['scroll' + name], domUtils['viewport' + name](d));
  };

  domUtils['viewport' + name] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = 'client' + name;
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, extra) {
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem, computedStyle);
  var cssBoxValue = 0;
  if (borderBoxValue == null || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue == null || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
    }
    return cssBoxValue;
  }
  if (borderBoxValueOrIsBorderBox) {
    var padding = extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle);
    return val + (extra === BORDER_INDEX ? 0 : padding);
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay(elem) {
  var val = undefined;
  var args = arguments;
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}

function css(el, name, v) {
  var value = v;
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value += 'px';
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils['outer' + first] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, val) {
    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

// 设置 elem 相对 elem.ownerDocument 的坐标
function setOffset(elem, offset) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var old = getOffset(elem);
  var ret = {};
  var current = undefined;
  var key = undefined;

  for (key in offset) {
    if (offset.hasOwnProperty(key)) {
      current = parseFloat(css(elem, key)) || 0;
      ret[key] = current + offset[key] - old[key];
    }
  }
  css(elem, ret);
}

module.exports = _extends({
  getWindow: function getWindow(node) {
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  offset: function offset(el, value) {
    if (typeof value !== 'undefined') {
      setOffset(el, value);
    } else {
      return getOffset(el);
    }
  },

  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var ret = {};
    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },
  scrollLeft: function scrollLeft(w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollLeft(w);
      }
      window.scrollTo(v, getScrollTop(w));
    } else {
      if (v === undefined) {
        return w.scrollLeft;
      }
      w.scrollLeft = v;
    }
  },
  scrollTop: function scrollTop(w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollTop(w);
      }
      window.scrollTo(getScrollLeft(w), v);
    } else {
      if (v === undefined) {
        return w.scrollTop;
      }
      w.scrollTop = v;
    }
  },

  viewportWidth: 0,
  viewportHeight: 0
}, domUtils);

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// gutenberg-support.js